// --------------------------------------------------------------------------------------------------------------------

'use strict'

// --------------------------------------------------------------------------------------------------------------------

function slugit(title) {
  if ( title === null ) return ''
  if ( title === undefined ) return ''
  if ( Number.isNaN(title) ) return ''
  if ( title === Infinity ) return ''
  if ( title instanceof Date ) return ''

  // booleans and numbers are okay

  title = String(title) || ''
  title = title.toLowerCase().trim()
  title = title.replace(/[\'\"]/g, '')
  title = title.replace(/[^0-9A-Za-z]+/g, '-')
  title = title.replace(/-+/g, '-').replace(/^-/, '').replace(/-$/, '')

  return title
}

// --------------------------------------------------------------------------------------------------------------------

module.exports = slugit

// --------------------------------------------------------------------------------------------------------------------
